// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-section {
  padding: 40px 20px;
  background: #023436;
  /* background: linear-gradient(to right, #f5f7fa, #e5edfc); */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
}

.modern-heading h2 {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 10px;
  background: linear-gradient(180deg, #FFFF00, rgb(72, 245, 28));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  /* text-fill-color: transparent; */
}


.modern-heading p {
  font-size: 18px;
  color: #e2dede;
  max-width: 600px;
  margin: 0 auto 50px;
}

.modern-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 19px;
padding: 0px 70px 0px 70px;
  justify-items: center;
}

.modern-card {
background-color: #fff;
  border-radius: 20px;
  padding: 25px 20px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  text-align: left; /* Change from center to left for better readability */
  display: flex;
  flex-direction: column;
  gap: 10px; /* adds spacing between items */
  border: 1px solid #e1e1e1;
  backdrop-filter: blur(6px);
}


.modern-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.modern-icon {
  font-size: 28px;
  color: #fff; /* White icon */
  background-color: #00695c; /* Default background color */
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 10px;
}

.modern-card h3 {
  margin: 0;
  font-size: 28px;
  color: #222;
  font-weight: 600;
}

.modern-card p {
  font-size: 16px;
  color: #0f0e0e;
  line-height: 1.6;
  margin: 0;
}


.modern-card a {
  margin-top: auto;
  font-size: 14px;
  color: #00695c;
  text-decoration: none;
  font-weight: 500;
}


.modern-center-img {
  grid-column: 2 / 3;
  grid-row: 1 / 3;
  text-align: center;
  position: relative;
  animation: floatY 6s ease-in-out infinite;
}

.modern-center-img img {
  max-width: 400px;
  height: 400px;
  border-radius: 16px;
  /* box-shadow: 0 0 25px rgba(0, 105, 92, 0.3); */
}
.image-card {
  position: relative;
  /* background: linear-gradient(135deg, rgb(179, 240, 26), rgb(90, 173, 237)); */
  border-radius: 16px;
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.image-card img {
  width: 80%;
  border-radius: 12px;
  margin-top: 110px;
  display: block;
  height: 440px;
}

.image-text {
  position: absolute;
  top: 20px;
  /* left: 20px; */

  color: #000;
  /* z-index: 2; */
  text-align: center;
}

.image-text h3 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 25px;display: flex;
  justify-content: center;
  align-items: center;

  color: #000;
}
.secureimage{
   width: 80%;
    border-radius: 12px;
  margin-top: 70px;
  /* display: block; */
  height: 220px;
}



.img-caption {
  display: block;
  margin-top: 10px;
  font-size: 18px;
  color: #c9cecd;
  font-weight: 500;
}

@keyframes floatY {
  0% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0); }
}
@media (max-width: 1024px) {
  .modern-grid {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }

  .modern-center-img {
    grid-column: auto;
    grid-row: auto;
    order: -1;
    margin-bottom: 30px;
  }

  .modern-card {
    max-width: 100%;
    margin-bottom: 20px;
  }

  .modern-heading h2 {
    font-size: 28px;
  }

  .modern-heading p {
    font-size: 16px;
    margin-bottom: 30px;
  }

  .modern-card h3 {
    font-size: 22px;
  }

  .modern-card p {
    font-size: 15px;
  }

  .modern-icon {
    font-size: 24px;
    width: 40px;
    height: 40px;
  }

  .image-card img {
    width: 100%;
    height: auto;
    margin-top: 30px;
  }

  .image-text h3 {
    font-size: 20px;
    padding: 0 10px;
  }

  .secureimage {
    width: 100%;
    height: auto;
    margin-top: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SecurePayment.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kCAAkC;AACpC;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX,0BAA0B;EACxB,qBAAqB;AACvB;;AAEA;AACA,sBAAsB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB,EAAE,sDAAsD;EACxE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,+BAA+B;EAC1C,yBAAyB;EACzB,0BAA0B;AAC5B;;;AAGA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,WAAW,EAAE,eAAe;EAC5B,yBAAyB,EAAE,6BAA6B;EACxD,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,+EAA+E;EAC/E,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;;EAEhB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB,CAAC,aAAa;EACjC,uBAAuB;EACvB,mBAAmB;;EAEnB,WAAW;AACb;AACA;GACG,UAAU;IACT,mBAAmB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;;;;AAIA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,2BAA2B,EAAE;EACnC,OAAO,wBAAwB,EAAE;AACnC;AACA;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".modern-section {\r\n  padding: 40px 20px;\r\n  background: #023436;\r\n  /* background: linear-gradient(to right, #f5f7fa, #e5edfc); */\r\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n  text-align: center;\r\n}\r\n\r\n.modern-heading h2 {\r\n  font-size: 40px;\r\n  font-weight: 700;\r\n  margin-bottom: 10px;\r\n  background: linear-gradient(180deg, #FFFF00, rgb(72, 245, 28));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  /* text-fill-color: transparent; */\r\n}\r\n\r\n\r\n.modern-heading p {\r\n  font-size: 18px;\r\n  color: #e2dede;\r\n  max-width: 600px;\r\n  margin: 0 auto 50px;\r\n}\r\n\r\n.modern-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 19px;\r\npadding: 0px 70px 0px 70px;\r\n  justify-items: center;\r\n}\r\n\r\n.modern-card {\r\nbackground-color: #fff;\r\n  border-radius: 20px;\r\n  padding: 25px 20px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.4s ease;\r\n  text-align: left; /* Change from center to left for better readability */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px; /* adds spacing between items */\r\n  border: 1px solid #e1e1e1;\r\n  backdrop-filter: blur(6px);\r\n}\r\n\r\n\r\n.modern-card:hover {\r\n  transform: translateY(-10px);\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.modern-icon {\r\n  font-size: 28px;\r\n  color: #fff; /* White icon */\r\n  background-color: #00695c; /* Default background color */\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.modern-card h3 {\r\n  margin: 0;\r\n  font-size: 28px;\r\n  color: #222;\r\n  font-weight: 600;\r\n}\r\n\r\n.modern-card p {\r\n  font-size: 16px;\r\n  color: #0f0e0e;\r\n  line-height: 1.6;\r\n  margin: 0;\r\n}\r\n\r\n\r\n.modern-card a {\r\n  margin-top: auto;\r\n  font-size: 14px;\r\n  color: #00695c;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n.modern-center-img {\r\n  grid-column: 2 / 3;\r\n  grid-row: 1 / 3;\r\n  text-align: center;\r\n  position: relative;\r\n  animation: floatY 6s ease-in-out infinite;\r\n}\r\n\r\n.modern-center-img img {\r\n  max-width: 400px;\r\n  height: 400px;\r\n  border-radius: 16px;\r\n  /* box-shadow: 0 0 25px rgba(0, 105, 92, 0.3); */\r\n}\r\n.image-card {\r\n  position: relative;\r\n  /* background: linear-gradient(135deg, rgb(179, 240, 26), rgb(90, 173, 237)); */\r\n  border-radius: 16px;\r\n  background-color: #ffffff;\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n\r\n.image-card img {\r\n  width: 80%;\r\n  border-radius: 12px;\r\n  margin-top: 110px;\r\n  display: block;\r\n  height: 440px;\r\n}\r\n\r\n.image-text {\r\n  position: absolute;\r\n  top: 20px;\r\n  /* left: 20px; */\r\n\r\n  color: #000;\r\n  /* z-index: 2; */\r\n  text-align: center;\r\n}\r\n\r\n.image-text h3 {\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin-bottom: 25px;display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  color: #000;\r\n}\r\n.secureimage{\r\n   width: 80%;\r\n    border-radius: 12px;\r\n  margin-top: 70px;\r\n  /* display: block; */\r\n  height: 220px;\r\n}\r\n\r\n\r\n\r\n.img-caption {\r\n  display: block;\r\n  margin-top: 10px;\r\n  font-size: 18px;\r\n  color: #c9cecd;\r\n  font-weight: 500;\r\n}\r\n\r\n@keyframes floatY {\r\n  0% { transform: translateY(0); }\r\n  50% { transform: translateY(-8px); }\r\n  100% { transform: translateY(0); }\r\n}\r\n@media (max-width: 1024px) {\r\n  .modern-grid {\r\n    grid-template-columns: 1fr;\r\n    padding: 0 20px;\r\n  }\r\n\r\n  .modern-center-img {\r\n    grid-column: auto;\r\n    grid-row: auto;\r\n    order: -1;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .modern-card {\r\n    max-width: 100%;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .modern-heading h2 {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .modern-heading p {\r\n    font-size: 16px;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .modern-card h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .modern-card p {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .modern-icon {\r\n    font-size: 24px;\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .image-card img {\r\n    width: 100%;\r\n    height: auto;\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .image-text h3 {\r\n    font-size: 20px;\r\n    padding: 0 10px;\r\n  }\r\n\r\n  .secureimage {\r\n    width: 100%;\r\n    height: auto;\r\n    margin-top: 30px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
